export const DECORATORS = {
  // Variables
  boxShadowDefault: '0px 0px 22px rgba(0, 0, 0, 0.1)',
  boxShadowLeft: '-8px 0px 22px rgba(0, 0, 0, 0.1)',
  boxShadowRight: '8px 0px 22px rgba(0, 0, 0, 0.1)',
};
